const EMMA_WEBVIEW_POST_MSG = 'EMMA_WEBVIEW_POST_MSG';

export const REACT_NATIVE_MESSAGE_TYPES = {
  CLOSE_EVENT: 'CLOSE_EVENT',
  WEBVIEW_APPEARED: 'WEBVIEW_APPEARED',
} as const;

type EventCallback = (detail: any) => void;

interface EventSubscription {
  action: string;
  type:
    | string
    | (typeof REACT_NATIVE_MESSAGE_TYPES)[keyof typeof REACT_NATIVE_MESSAGE_TYPES];
  callback: EventCallback;
}

class ReactNativeMessageManager {
  private static instance: ReactNativeMessageManager;
  private subscriptions: EventSubscription[] = [];
  private isListenerAttached = false;

  private constructor() {
    this.attachListener();
  }

  public static getInstance(): ReactNativeMessageManager {
    if (!ReactNativeMessageManager.instance) {
      ReactNativeMessageManager.instance = new ReactNativeMessageManager();
    }
    return ReactNativeMessageManager.instance;
  }

  private detachListener() {
    document.removeEventListener('reactNativeMessage', () => {
      console.log('reactNativeMessage event listener detached');
    });
    this.isListenerAttached = false;
  }

  private attachListener() {
    if (this.isListenerAttached) this.detachListener();

    const handleMessage = (e: CustomEvent) => {
      const { action, payload } = e?.detail || {};

      this.subscriptions.forEach((subscription) => {
        if (
          subscription.action === action &&
          subscription.type === payload?.type
        ) {
          subscription.callback(e.detail);
        }
      });
    };

    document.addEventListener('reactNativeMessage', handleMessage);
    this.isListenerAttached = true;
  }

  public subscribe(type: string, callback: EventCallback): () => void {
    const subscription: EventSubscription = {
      action: EMMA_WEBVIEW_POST_MSG,
      type,
      callback,
    };

    this.subscriptions.push(subscription);

    // Return unsubscribe function
    return () => {
      this.subscriptions = this.subscriptions.filter(
        (sub) => sub !== subscription,
      );
    };
  }
}

export const eventManager = ReactNativeMessageManager.getInstance();
